import { useEffect, useState } from "react";
import { Text } from "../models/post";
// @ts-ignore
import { CKEditor } from '@ckeditor/ckeditor5-react';
// @ts-ignore
import BalloonEditor from '@ckeditor/ckeditor5-build-balloon';
import styled from "styled-components";
import { CloseRounded } from "@mui/icons-material";

export const DeleteButton = styled.div`
  position: absolute;
  z-index: 1;
  top: .5rem;
  right: .5rem;
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000;
  color: white;
  transition: .15s;
  cursor: pointer;
  opacity: ${({show}: {show: boolean}) => show ? 0.5 : 0};
  border-radius: 50%;
`;

export default function TextComponent(props: {
  text: Text;
  update: (text: string) => void;
  deleteContent: () => void;
}) {
  const [text, setText] = useState(props.text.text);
  const onChange = (_event: any, editor: { getData: any; }) => {
    setText(editor.getData());
  };
  useEffect(() => {
    props.update(text);
  }, [text, props]);
  const [showDelete, setShowDelete] = useState(false);

  return <div onMouseMove={() => setShowDelete(true)} onMouseEnter={() => setShowDelete(true)} onMouseLeave={() => setShowDelete(false)} style={{
    position: "relative"
  }}>
    <DeleteButton show={showDelete} onClick={props.deleteContent}>
      <CloseRounded />
    </DeleteButton>
    <CKEditor editor={BalloonEditor} data={text} config={{
      toolbar: ['heading', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo'],
      placeholder: "Text schreiben..."
    }} onChange={onChange} />
  </div>;
}
